/** One integer draw per batch. The 10,000 slots make the advertised odds exact. */
export const REFINERY_PURITY_RTP_BPS = 9_700;
export const REFINERY_PURITY_MAX_MULTIPLIER_MICROS = 20_000_000;
export const REFINERY_PURITY_OUTCOMES = [
  { upperExclusive: 1_000, multiplierBps: 8_500 },
  { upperExclusive: 4_000, multiplierBps: 9_000 },
  { upperExclusive: 5_945, multiplierBps: 9_500 },
  { upperExclusive: 8_445, multiplierBps: 10_200 },
  { upperExclusive: 9_500, multiplierBps: 10_500 },
  { upperExclusive: 9_995, multiplierBps: 11_000 },
  { upperExclusive: 10_000, multiplierBps: 200_000 },
] as const;

export function refineryPurityMultiplierBps(roll: number): number {
  if (!Number.isInteger(roll) || roll < 0 || roll >= 10_000) throw new RangeError("refinery_purity_roll_out_of_range");
  return REFINERY_PURITY_OUTCOMES.find((outcome) => roll < outcome.upperExclusive)!.multiplierBps;
}

/** Round toward the player so even a base-unit-sized batch cannot lose over 15%. */
export function refineryPurityOutput(raw: bigint, multiplierBps: number): bigint {
  return (raw * BigInt(multiplierBps) + 9_999n) / 10_000n;
}
